<template>
	<div class="tpl feed-back-wrap">
		<mt-header title="帮助与反馈" fixed>
			<router-link :to="{name:'my-setting'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="form-content">
			<div class="text">
				<textarea v-model="text" maxlength="200" placeholder="请输入遇到的问题或建议" autofocus ref="fonts" @keyup="culFonts"></textarea>
				<span>{{fontNum}}/20</span>
			</div>
			<div class="tel">
				<input type="tel" placeholder="填写联系电话(选填，以便我们联系到您)" v-model="tel">
			</div>
			<p class="title">添加图片描述(不超过3张)</p>
			<div class="upload-imgs">
				<div class="img-box" v-for="(item,index) in imgs.slice(0,3)">
					<div class="img-box-inner">
						<input type="file" accept="image/*" name="" id="upload-img" @change="uploads" />
						<span v-if="!item" class="add-btn">+</span>
						<img v-if="item" :src="item" alt="" />
					</div>
					<span v-if="item" class="delete-btn" @click="deleteImg($event,index)">&times;</span>
				</div>
			</div>

			<p class="submit-btn">
				<button @click="submitData">提交</button>
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "feedback",
		data() {
			return {
				uid: "",
				text: "",
				tel: "",
				fontNum: 0,
				imgs: [""],
				files: [],
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
		},
		methods: {
			culFonts() {
				console.log(this.$refs.fonts.value.length);
				this.fontNum = this.$refs.fonts.value.length;
				console.log()
				if(this.fontNum > 20) {
					this.$toast({
						message: "字数超过限制了哦~",
						position: "bottom",
						duration: 2000
					});
					this.text = this.text.substr(0, 20);
					this.fontNum = 20;
				}
			},
			deleteImg(event, i) {
				let ele = event.currentTarget.previousElementSibling.childNodes[0];
				ele.value = "";
				this.imgs.splice(i, 1)
			},
			uploads(e) {
				console.log(this.formData)
				const file = e.target.files[0];

				let URL = window.URL || window.webkitURL; // 与上传没有关系（可选）
				this.imgs.splice(this.imgs.length - 1, 0, URL.createObjectURL(file)) // 这是为了显示图片而已， 与上传没有关系（可选）
				console.log(this.imgs);
				this.files.push(file); // 'file[]' 代表数组 其中`file`是可变的
				console.log(this.files)
			},
			submitData() {
				let _this = this;
				if(this.uid == "" || undefined || null) {
					_this.$toast({
						message: "你还没有登录哦~",
						position: "bottom",
						duration: 2000
					});
				} else if(this.text == "" || undefined || null) {
					_this.$toast({
						message: "请填写你的问题描述",
						position: "bottom",
						duration: 2000
					});
				} else if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					_this.$toast({
						message: "请检查你的手机号是否正确",
						position: "bottom",
						duration: 2000
					});
				} else {
					let b = new FormData();
					b.append("uid", this.uid);
					b.append("text", this.text);
					b.append("contact_information", this.tel);
					this.files.map(item => {
						b.append("attach", item);
					})
					console.log(b.getAll("attach"))
					this.$axios({
						url:"Currency/UserFeedback",
						method:"post",
						data:b,
					}).then(res=>{
						console.log(res);
						if(res.data.code == 200) {
							this.ContactSuccess();
						}
					}).catch(err=>{
						console.log(err)
					})
				}

			},
			ContactSuccess() {

			}
		}
	}
</script>

<style scoped>
	.feed-back-wrap {
		padding-top: 2.5rem;
	}
	
	.form-content {
		padding: 1rem;
		background: #fff;
	}
	
	.text {
		position: relative;
	}
	
	.text textarea {
		width: 100%;
		height: 8rem;
		resize: none;
		padding: 0.2rem 0.4rem;
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.5rem;
		display: block;
		border: 1px solid #ccc;
		outline: 0;
		border-radius: 4px;
	}
	
	.text span {
		position: absolute;
		right: 0;
		bottom: 0;
		font-size: 0.65rem;
		color: #7b7b7b;
		padding: 0.2rem;
		display: block;
	}
	
	.title {
		font-size: 0.8rem;
		margin: 0.8rem 0 0.3rem;
		color: #7b7b7b;
	}
	
	.upload-imgs {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}
	
	.upload-imgs .img-box {
		width: 33%;
		padding: 0.5rem;
		height: 7rem;
		position: relative;
	}
	
	.upload-imgs .img-box-inner {
		width: 100%;
		height: 100%;
		border-radius: 5px;
		overflow: hidden;
		background: #f4f4f4;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
	
	.upload-imgs .img-box-inner img {
		max-width: 100%;
		max-height: 100%;
	}
	
	.upload-imgs .img-box-inner input {
		width: 100%;
		height: 100%;
		opacity: 0;
		position: absolute;
		z-index: 10;
	}
	
	.upload-imgs .img-box .delete-btn {
		position: absolute;
		top: 0;
		right: 0;
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		background: red;
		color: #fff;
		text-align: center;
		line-height: 1rem;
	}
	
	.upload-imgs .img-box-inner .add-btn {
		position: absolute;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 3rem;
		color: #ccc;
		font-weight: lighter;
	}
	
	.tel {
		margin-top: 1rem;
	}
	
	.tel input {
		width: 100%;
		height: 2.2rem;
		padding: 0 0.4rem;
		font-size: 0.8rem;
		color: #282828;
		line-height: 1.5rem;
		display: block;
		border: 1px solid #ccc;
		outline: 0;
		border-radius: 4px;
	}
	
	.submit-btn {
		text-align: center;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%
	}
	
	.submit-btn button {
		width: 100%;
		height: 3rem;
		background: linear-gradient(45deg, rgba(118, 68, 250, 1) 0%, rgba(156, 124, 255, 1) 100%);
		border: 0;
		outline: 0;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/FeedBack.vue